import React from 'react';
import ReactDOM from 'react-dom';
import MediaBrowserPopup from './MediaBrowserPopup.jsx';

var MediaBrowserService = {
  openMediaBrowser: function(
    onFileSelect,
    onClose,
    mediaManager,
    multipleSelect = false,
  ) {
    var panelComponent = document.getElementById('media-browser-popup');
    if (panelComponent !== null) {
      ReactDOM.render(
        <MediaBrowserPopup
          onFileSelect={onFileSelect}
          onClose={onClose}
          mediaManager={mediaManager}
          multipleSelect={multipleSelect}
        />,
        panelComponent,
      );
    }
  },

  closeMediaBrowser: function() {
    ReactDOM.unmountComponentAtNode(
      document.getElementById('media-browser-popup'),
    );
  },
};

export default MediaBrowserService;



// WEBPACK FOOTER //
// ./src/js/app/cm/components/mediaBrowser/MediaBrowserService.jsx